// eslint-disable-next-line no-unused-vars
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      height: '100%',
      width: '100%',
    },
    registrationDate: {
      color: '#777',
      fontSize: '0.9em',
      paddingLeft: theme.spacing(2),
    },
    list: {
      width: '100%',
    },
    listItem: {
      display: 'flex',
      flexDirection: 'column',
    },
    table: {
      '& thead': {
        background: `linear-gradient(to right, ${theme.palette.colors.blue}, ${theme.palette.colors.green})`,
      },
      '& thead th': {
        color: '#fff',
      },
      '& thead tr > *': {
        padding: theme.spacing(1, 2),
      },
      '& tbody tr > *': {
        padding: theme.spacing(0.5, 2),
      },
      '& tbody tr:nth-of-type(odd)': {
        background: '#fff',
      },
      '& tbody tr:nth-of-type(even)': {
        background: '#eeea',
      },
    },
    icon: {
      '& > *': {
        fill: 'rgba(0, 0, 0, 0.54)',
      },
    },
  }),
);

export default useStyles;
